import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const NoPermission: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md px-6">
        <ShieldExclamationIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          {t('noPermission.title', '접근 권한이 없습니다')}
        </h2>
        <p className="text-sm text-gray-500 mb-6">
          {t('noPermission.description', '이 페이지에 접근할 수 있는 권한이 없습니다. 관리자에게 문의하세요.')}
        </p>
        <Link
          to="/dashboard"
          className="inline-block px-6 py-2.5 rounded-lg bg-blue-500 text-white font-semibold hover:bg-blue-600 transition-colors"
        >
          {t('noPermission.backToDashboard', '대시보드로 돌아가기')}
        </Link>
      </div>
    </div>
  );
};

export default NoPermission;
